import { media, P, PProps, TelLink, TelLinkProps } from 'ia-react-core';
import { FC } from 'react';
import styled from 'styled-components';

export const StyledDiv = styled.div`
  display: flex;
  flex-flow: wrap;
  ${media.lg`
    padding-left: 12px;
  `};`;

export const StyledTitle = styled<FC<PProps>>(P)`
  font-weight: bold;
  font-size: 17px;
  margin-bottom: 20px;
`;

export const StyledSection = styled.section`
  display: flex;
  flex-flow: wrap;
  ${media.lg`
    padding-left: 12px;
  `};
`;

export const StyledInformation = styled.div`
  padding-right: 16px;
  flex: 1 0 200px;
  min-width: 40%;
  max-width: none;
  &:last-child {
    padding-bottom: 0;
  }
  &:first-child {
    ${media.sm`
      padding-bottom: 0px;
  `};
    padding-bottom: 24px;
  }
`;

export const StyledTelLink = styled<FC<TelLinkProps>>(TelLink)`
  color: ${({ theme }) => theme.colors.blue5};
  font-weight: 600;
`;
